import math from './math';
import stack from './stack';
import string from './string';
import iterators from './iterators';
import logic from './logic';
import aggregate from './aggregate';
import quotations from './quotations';
import controlflow from './controlflow';
import recursion from './recursion';
import internal from './internal';

export default Object.assign(
  {},
  math,
  stack,
  string,
  iterators,
  logic,
  aggregate,
  quotations,
  controlflow,
  recursion,
  internal
);
